import { BillPage_BillFragment } from "src/fragments/circularFragments.generated";
import { BillType } from "src/generated/graphqlTypes";
export function isHeadlessBill(bill: BillPage_BillFragment) {
  return bill.lineItems.isEmpty || !bill.lineItems[0].commitmentLineItem;
}
export function hasDraws(bill: BillPage_BillFragment) {
  return bill.lineItems.some((li) => li.commitmentDraw);
}
export function isDepositBill(bill: BillPage_BillFragment) {
  return bill.type.code === BillType.Deposit;
}
